import type { OrderedJSONSchema } from "@elephant-healthcare/yupify";
import { omit } from "ramda";
import React from "react";
import type { SchemaDescription } from "yup/lib/schema";

type DescribedProps = {
  fieldDef: OrderedJSONSchema;
  describedFieldSchema: SchemaDescription;
};

// DynamicField will pass `describedFieldSchema` and `fieldDef` to fields in the `fieldMap`,
// however not all componets need/accept these props.
// To avoid them being spread to the DOM if the component does not need them,
// wrap components with this HOC to strip these props out
export default function dynamicField<P>(Component: React.ComponentType<P>) {
  return (props: P & DescribedProps): React.ReactElement => {
    const restProps = omit(["fieldDef", "describedFieldSchema"], props) as Pick<
      P,
      Exclude<keyof P, keyof DescribedProps>
    >;
    return <Component {...(restProps as P)} />;
  };
}
